import React from "react";
import { object, func, string } from "prop-types";
import { connect } from "react-redux";
import { LoadMoreCollectionStories } from "@quintype/components";

import More from "../../../atoms/More";
import RightImageLeftNews from "../../../molecules/RightImageLeftNews";

import { setLoading } from "../../../helper/actions";
import { staticTexts } from "../../../utils/Translate";
import DfpAd from "../../../dfp-ad";

import "./organism1.m.css";

const Organism1 = ({ collection, setLoading, lang, adSlotId1 = "", adSlotId2 = "" }) => {
  const numStoriesToLoad = 6;
  const storyList = collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (!(storyList && storyList.length)) {
    return null;
  }

  const MoreCollectionStories = (params, numStoriesToLoad) => {
    const { stories, onLoadMore, noMoreStories, loading } = params;
    const firstSetStories = stories.slice(0, 4);
    const remainingStories = stories.slice(4, stories.length);

    setLoading(loading);

    const MoreComponent = (
      <div styleName={`load-more-view`}>
        <More type="load-more" text={staticTexts(lang).more} onClick={onLoadMore} />
      </div>
    );

    return (
      <div>
        {firstSetStories.map((story, index) => (
          <RightImageLeftNews showExcerpt={global.deviceWidth > 876} key={index} story={story} />
        ))}

        <div styleName="ad-wrapper">
          <DfpAd adtype="News_336x280_R3" slotId={`${adSlotId1}-1`} />
        </div>

        {remainingStories.map((story, index) => (
          <React.Fragment key={index}>
            {index % 6 === 0 && index >= 6 && (
              <div styleName="ad-wrapper">
                <DfpAd adtype="News_336x280_R3" slotId={`${adSlotId2}-${index / 6 + 1}`} />
              </div>
            )}
            <RightImageLeftNews key={index} story={story} showExcerpt={global.deviceWidth > 876} />
          </React.Fragment>
        ))}

        {numStoriesToLoad <= stories.length && !noMoreStories ? MoreComponent : null}
      </div>
    );
  };

  return (
    <LoadMoreCollectionStories
      template={(e) => MoreCollectionStories(e, numStoriesToLoad)}
      collectionSlug={collection.slug}
      data={Object.assign(
        {},
        { collection },
        { stories: [...storyList.map((story) => story).slice(0, 10)] },
        { storiesPerPage: numStoriesToLoad }
      )}
      numStoriesToLoad={numStoriesToLoad}
      params={{ "item-type": "story" }}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

Organism1.propTypes = {
  collection: object.isRequired,
  setLoading: func,
  lang: string,
  adSlotId1: string,
  adSlotId2: string,
};

export default connect(null, mapDispatchToProps)(Organism1);
